import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
    collection,
    getDocs,
    deleteDoc,
    doc,
    query,
    orderBy
} from "firebase/firestore";

import { db } from "../../firebase/firebase";

import "../../assets/css/admin/managePackages.css";

import Sidebar from "../Sidebar";
import Footer from "../../components/common/Footer";
import AdminNavbar from "../AdminNavbar";

function ManagePackages() {

    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);
const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null
});
    const navigate = useNavigate();

    useEffect(() => {

        fetchPackages();

    }, []);

    const fetchPackages = async () => {

        try {

            const q = query(
                collection(db, "packages"),
                orderBy("createdAt", "desc")
            );

            const snapshot = await getDocs(q);

            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            setPackages(data);

        }

        catch (error) {

            console.log(error);
            setPopup({
    show: true,
    type: "error",
    message: "Failed to Load Packages"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

        finally {

            setLoading(false);

        }

    };

    const deletePackage = async (id) => {

       

        try {

            await deleteDoc(doc(db, "packages", id));

            setPackages(prev =>
                prev.filter(item => item.id !== id)
            );

            setPopup({
    show: true,
    type: "success",
    message: "Package Deleted Successfully"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

        catch (error) {

            console.log(error);
            setPopup({
    show: true,
    type: "error",
    message: "Delete Failed"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

    };

    return (
       <>
       {popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success"
                ? "✓"
                : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>{popup.message}</p>

        </div>

    </div>

)}
{deleteModal.show && (

    <div className="luxury-modal-overlay">

        <div className="luxury-modal">

            <h2>

                Delete Package?

            </h2>

            <p>

                This action cannot be undone.

            </p>

            <div className="luxury-modal-actions">

                <button
                    className="cancel-btn"
                    onClick={() =>
                        setDeleteModal({
                            show: false,
                            id: null
                        })
                    }
                >
                    Cancel
                </button>

                <button
                    className="delete-btn"
                    onClick={() => {

                        deletePackage(
                            deleteModal.id
                        );

                        setDeleteModal({
                            show: false,
                            id: null
                        });

                    }}
                >
                    Delete
                </button>

            </div>

        </div>

    </div>

)}
         <div className="admin-layout">
                <AdminNavbar/>
         <div className="admin-main">

             <Sidebar />

            <div className="lux-package-page">

                {/*==========================
                        HEADER
                ===========================*/}

                <div className="lux-package-header">

                    <h1 className="lux-package-title">
                        Package Management
                    </h1>

                    <button
                        className="lux-package-add-btn"
                        onClick={() =>
                            navigate("/admin/add-package")
                        }
                    >
                        ➕ Add Package
                    </button>

                </div>

                {/*==========================
                        CONTENT
                ===========================*/}

                {loading ? (

                    <div className="lux-package-loading">

                        <h2>Loading Packages...</h2>

                    </div>

                ) : packages.length === 0 ? (

                    <div className="lux-package-empty">

                        <h2>No Packages Found</h2>

                    </div>

                ) : (

                    <div className="lux-package-grid">

                        {packages.map((pkg) => (

                            <div
                                key={pkg.id}
                                className="lux-package-card"
                            >

                                <div className="lux-package-image-wrapper">

                                    <img
                                        src={pkg.image}
                                        alt={pkg.title}
                                        className="lux-package-image"
                                    />

                                </div>

                                <div className="lux-package-content">

                                    <h3 className="lux-package-name">
                                        {pkg.title}
                                    </h3>

                                    <h4 className="lux-package-price">
                                        {pkg.price}
                                    </h4>

                                    <ul className="lux-package-feature-list">

                                        {pkg.features?.map((item, index) => (

                                            <li
                                                key={index}
                                                className="lux-package-feature-item"
                                            >
                                                {item}
                                            </li>

                                        ))}

                                    </ul>

                                    <div className="lux-package-action-buttons">

                                        <Link
                                            to={`/admin/edit-package/${pkg.id}`}
                                            className="lux-package-edit-btn"
                                        >
                                            Edit
                                        </Link>

                                        <button
                                            className="lux-package-delete-btn"
                                            onClick={() =>
    setDeleteModal({
        show: true,
        id: pkg.id
    })
}
                                        >
                                            Delete
                                        </button>

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                )}

               

            </div>

        </div>
        </div>
         <Footer />
    </>
    );

}

export default ManagePackages;